module.exports = __webpack_public_path__ + "img/profile-light-outline.ceb1a645.svg";